export const SNAPSHOT_LADDER_PROFIT_REQUEST = 'SNAPSHOT_LADDER_PROFIT_REQUEST'
export const SNAPSHOT_LADDER_PROFIT_SUCCESS = 'SNAPSHOT_LADDER_PROFIT_SUCCESS'
export const SNAPSHOT_LADDER_PROFIT_FAIL = 'SNAPSHOT_LADDER_PROFIT_FAIL'
export const SNAPSHOT_LADDER_PROFIT_RESET = 'SNAPSHOT_LADDER_PROFIT_RESET'

export const HISTORICAL_DATA_REQUEST = 'HISTORICAL_DATA_REQUEST'
export const HISTORICAL_DATA_SUCCESS = 'HISTORICAL_DATA_SUCCESS'
export const HISTORICAL_DATA_FAIL = 'HISTORICAL_DATA_FAIL'
export const HISTORICAL_DATA_RESET = 'HISTORICAL_DATA_RESET'